import { VehicleNature } from '@ail/contracts-api'
import { vehicleNatureValuesDict } from '../../../../types/constants'
interface Props {
  nature: VehicleNature
}
export default function ObjTypeCell({ nature }: Props) {
  return (
    <div className="objTypeCell">
      <i className={vehicleNatureValuesDict[nature] || 'icon-4u'} />
    </div>
  )
}
